import { render, staticRenderFns } from "./SchedulesTransportForm.vue?vue&type=template&id=47f589e4&"
import script from "./SchedulesTransportForm.vue?vue&type=script&lang=js&"
export * from "./SchedulesTransportForm.vue?vue&type=script&lang=js&"
import style0 from "./SchedulesTransportForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports